import { reactive } from "vue";

const stored = sessionStorage.getItem("matttest-console-config");
const parsed = stored ? JSON.parse(stored) as Partial<ConsoleConfig> : {};

export type ConsoleConfig = {
  baseUrl: string;
  clientKey: string;
  adminKey: string;
};

export const config = reactive<ConsoleConfig>({
  baseUrl: parsed.baseUrl ?? import.meta.env.VITE_SERVICE_BASE_URL ?? "",
  clientKey: parsed.clientKey ?? import.meta.env.VITE_CLIENT_KEY ?? "",
  adminKey: parsed.adminKey ?? import.meta.env.VITE_ADMIN_KEY ?? "",
});

export function saveConfig(next: ConsoleConfig): void {
  config.baseUrl = next.baseUrl.replace(/\/$/, "");
  config.clientKey = next.clientKey.trim();
  config.adminKey = next.adminKey.trim();
  sessionStorage.setItem("matttest-console-config", JSON.stringify(config));
}
